module.exports = __webpack_public_path__ + "static/media/frutiger-65bold.6d4c317c.svg";